import { useEffect } from 'react';

/**
 * useTikTokEmbed
 * 
 * Hook SIÊU ỔN ĐỊNH để render TikTok video trên mọi trình duyệt & thiết bị:
 * 1. Ưu tiên 1: Tải và kích hoạt Trình phát chính thức của TikTok qua embed.js.
 * 2. Ưu tiên 2 (Fallback tự động): Nếu sau 1.5 giây embed.js chưa thay thế xong blockquote
 *    (do mạng chậm, chuyển trang React Router hoặc trình duyệt chặn script),
 *    hook sẽ tự động tạo khung iframe player dự phòng để ĐẢM BẢO 100% video LUÔN HIỂN THỊ
 *    VÀ XEM ĐƯỢC ỔN ĐỊNH.
 */
const useTikTokEmbed = (contentRef, deps = []) => {
    useEffect(() => {
        let timerId = null;
        let attempts = 0;
        const maxAttempts = 8; // 8 * 200ms = 1.6s

        const processTikTokEmbeds = () => {
            const container = contentRef?.current || document;
            const tiktokBlocks = container.querySelectorAll('blockquote.tiktok-embed');

            if (tiktokBlocks.length === 0) return;

            // 1. Thử gọi TikTok SDK render nếu script đã load
            if (window.tiktokEmbed && typeof window.tiktokEmbed.lib?.render === 'function') {
                try {
                    window.tiktokEmbed.lib.render(tiktokBlocks);
                } catch (e) {
                    console.warn('TikTok embed render error:', e);
                }
            } else {
                // Đảm bảo script được nạp vào DOM
                const existingScript = document.querySelector('script[src*="tiktok.com/embed.js"]');
                if (!existingScript) {
                    const script = document.createElement('script');
                    script.src = 'https://www.tiktok.com/embed.js';
                    script.async = true;
                    document.body.appendChild(script);
                }
            }

            attempts++;

            // 2. Fallback tự động sau 1.6 giây nếu TikTok embed.js chưa biến blockquote thành iframe
            if (attempts >= maxAttempts) {
                const remainingBlocks = container.querySelectorAll('blockquote.tiktok-embed');
                remainingBlocks.forEach((block) => {
                    const videoId = block.getAttribute('data-video-id');
                    if (videoId) {
                        const wrapper = document.createElement('div');
                        wrapper.className = 'tiktok-embed-wrapper';
                        wrapper.style.cssText = 'display:flex;justify-content:center;margin:1.5rem 0;width:100%;';

                        const iframe = document.createElement('iframe');
                        iframe.src = `https://www.tiktok.com/player/v1/${videoId}?autoplay=0`;
                        iframe.style.cssText = 'width:360px;height:650px;max-width:100%;border:none;border-radius:16px;box-shadow:0 8px 32px rgba(0,0,0,0.15);background:#000;';
                        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
                        iframe.allowFullscreen = true;
                        iframe.title = 'TikTok video player';

                        wrapper.appendChild(iframe);
                        if (block.parentNode) {
                            block.parentNode.replaceChild(wrapper, block);
                        }
                    }
                });
            } else {
                timerId = setTimeout(processTikTokEmbeds, 200);
            }
        };

        timerId = setTimeout(processTikTokEmbeds, 100);

        return () => {
            if (timerId) clearTimeout(timerId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

export default useTikTokEmbed;
